import { Container } from '@mui/material';
import { AddExercise } from 'components/templates';
import React from 'react';

export const ExerciseFormView = () => {
  return (
    <Container component="main" maxWidth="xl" sx={{ width: '75%' }}>
      <AddExercise />
    </Container>
  );
};
